export default __webpack_public_path__ + "static/media/workshopflute.77a1aa69.jpg";